import React, { Component } from 'react';

import { connect } from 'react-redux';

import { isEmpty, get } from 'lodash';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Divider from '@material-ui/core/Divider';
import Grow from '@material-ui/core/Grow';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

import CompanyCard from '../../components/CompanyCard';
import CreateCompanyModal from '../Modals/CreateCompanyModal';
import EditCompanyModal from '../Modals/EditCompanyModal';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './CompanyOverviewCard.module.css';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as CoreActions from '../../actions/coreActions';
import * as CompanyInfoActions from '../../actions/companyInfoActions';

const BILLING_STATUS = ['Awaiting Confirmation', 'On Hold', 'Ok', 'Delinquent'];

class CompanyOverviewCard extends Component {
    state = {
        createModalOpen: false,
        editModalOpen:   false,
        menuOpen:        false,
        modalTitle:      null,
        modalType:       null
    }

    async componentDidMount() {
        await this.props.fetchCompanyContractorTypes();
    }

    handleCreateModal = () => {
        this.setState(state => ({
            createModalOpen: true,
            menuOpen:        false
        }));
    }

    handleEditModal = () => {
        this.setState(state => ({
            editModalOpen: true,
            menuOpen:      false
        }));
    }

    handleCloseModal = () => {
        this.setState(state => ({
            createModalOpen: false,
            editModalOpen:   false
        }));
    }

    handleToggleMenu = () => {
        let toggleState = this.state.menuOpen;

        this.setState({menuOpen: !toggleState});
    }

    handleClickAway = () => {
        this.setState({menuOpen: false});
    }

    iconSelect = () => {
        const { companyInfo } = this.props;

        switch (get(companyInfo, 'billingStatus', '')) {
            case 0:
                return '/assets/images/billing-delinquent.svg';
            case 1:
                return '/assets/images/billing-on-hold.svg';
            case 2:
                return '/assets/images/billing-ok.svg';
            case 3:
                return '/assets/images/billing-delinquent.svg';
            default:
                return '';
        }
    }

    populateCompanyOverview = () => {
        const { currentScopes, companyInfo } = this.props;

        const companyContractorType = get(companyInfo, 'companyContractorType', []);
        const companyBillingStatus = get(companyInfo, 'billingStatus', []);
        const companyAddress = get(companyInfo, 'companyAddress', '');
        const companyName = get(companyInfo, 'companyName', null);

        let displayedCompanyContractorType = isEmpty(companyContractorType) ? '' : companyContractorType.join(', ');
        let displayedCompanyBillingStatus = isEmpty(companyBillingStatus) ? '' : BILLING_STATUS[companyBillingStatus];
        let displayedCompanyEnabledStatus = get(companyInfo, 'enabled') ? 'Yes' : 'No';
        let anchorEl;

        if (this.props.companies.length > 0) {
            return (
                <div className={classes.innerContainer}>
                    <div className={classes.companyInfo}>
                        <div className={classes.companyInfoRow}>
                            <div className={classes.label}>
                                Address
                            </div>
                            <div className={classes.data}>
                                {companyAddress}
                            </div>
                        </div>
                        <div className={classes.companyInfoRow}>
                            <div className={classes.label}>
                                Contractor Type
                            </div>
                            <div className={classes.contractorTypeData}>
                                <div className={classes.contractorTypeDataContent}>
                                    {displayedCompanyContractorType}
                                </div>
                            </div>
                        </div>
                        <div className={classes.companyInfoRow}>
                            <div className={classes.label}>
                                Billing Status
                            </div>
                            <div className={classes.data}>
                                {displayedCompanyBillingStatus}
                                <img
                                    className={classes.icon}
                                    src={this.iconSelect()}
                                    alt="billing status icon"
                                />
                            </div>
                        </div>
                        <div className={classes.companyInfoRow}>
                            <div className={classes.label}>
                                Enabled
                            </div>
                            <div className={classes.data}>
                                {displayedCompanyEnabledStatus}
                            </div>
                        </div>
                    </div>
                    <ClickAwayListener onClickAway={this.handleClickAway}>
                        <React.Fragment>
                            <Button
                                buttonRef={node => {
                                    anchorEl = node;
                                }}
                                color="primary"
                                variant="contained"
                                aria-owns={this.state.menuOpen ? 'company-list' : null}
                                aria-haspopup="true"
                                onClick={this.handleToggleMenu}
                            >
                                <span>{companyName || 'Select Company'}</span>
                                <i className="fas fa-caret-down" />
                            </Button>
                            <Popper
                                open={this.state.menuOpen}
                                anchorEl={anchorEl}
                                transition
                                disablePortal
                                className={classes.companyMenu}
                            >
                                {({ TransitionProps }) => (
                                    <Grow
                                        {...TransitionProps}
                                        id="company-list"
                                    >
                                        <Paper>
                                            <MenuList>
                                                {isAllowed(currentScopes, Permissions('adminFull')) &&
                                                <div>
                                                    <MenuItem onClick={this.handleEditModal}>Edit {companyName}</MenuItem>
                                                    <Divider />
                                                </div>
                                                }
                                                <MenuItem onClick={this.handleCreateModal}> + Create New Company</MenuItem>
                                            </MenuList>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </React.Fragment>
                    </ClickAwayListener>
                </div>
            );
        }

        return (
            <div className={classes.buttonContainer}>
                <div>You have not yet created a Company.</div>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleCreateModal}
                >
                    Create Company
                </Button>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <CompanyCard
                    title="Company Overview"
                    imagePath="/assets/images/appartmentComplexFlat.svg"
                >
                    {this.populateCompanyOverview()}
                </CompanyCard>
                <CreateCompanyModal
                    open={this.state.createModalOpen}
                    close={this.handleCloseModal}
                    title="Create Company"
                />
                <EditCompanyModal
                    open={this.state.editModalOpen}
                    close={this.handleCloseModal}
                    title="Edit Company"
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        companies:       state.core.companies,
        companyInfo:     state.companyInfo,
        currentScopes:   state.core.currentScopes,
        contractorTypes: state.companyInfo.contractorTypes
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...CoreActions,
    ...CompanyInfoActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyOverviewCard);
